
import { defineComponent, onMounted } from 'vue';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  setup() {
    function goHome() {
      router.push('/');
    }

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      goHome,
    };
  },
});
